// Images.
import ComputerImg from "../assets/computer1.jpg";
// Components.
import { ModalButton } from "./contactModal/ModalButton";
// styles.
import { ServicesSection } from "../styles/features/ServicesStyles";

export const Services: React.FC = () => {
  return (
    <ServicesSection className="services">
      <div className="services-benefits">
        <h2>Implementa soluciones digitales... </h2>
        <p>
          Al adaptar tu negocio a un entorno digital, impulsarás el crecimiento
          de tu marca,
          <br />
          aumentarás tu alcance y la expansión de tu catálogo de productos.
        </p>
        <div className="div-img">
          <img alt="Imagen herramientas digitales" src={ComputerImg} />
        </div>
      </div>

      <div className="services-info">
        <h2>...con estas herramientas </h2>
        <div className="services-grid">
          <div>
            <h3>Páginas web</h3>
            <p>
              Ofrece a tus clientes una experiencia interactiva para aumentar la
              efectividad de tus campañas de marketing. Estas herramientas
              impulsarán el crecimiento de tu negocio al convertir visitantes en
              clientes leales.
            </p>
          </div>
          <div>
            <p className="sum-symbol">+</p>
          </div>
          <div>
            <h3>Herramientas digitales</h3>
            <p>
              Imagina tener control total sobre tu inventario con
              actualizaciones en tiempo real. Esto no solo mejorará la
              eficiencia de tus ventas, sino que también optimizará la gestión
              de tus productos y prevenirá futuras pérdidas.
            </p>
          </div>
        </div>
        <ModalButton />
      </div>
    </ServicesSection>
  );
};

// Descubre cómo podemos potenciar tu negocio con nuestras soluciones
// tecnológicas.
